<template>
  <div class="k-msg">
    <div class="k-m-title">{{ title}}</div>
    <div class="k-m-describe">
      {{describe}}
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KaresMessage',
  props: {
    title: {
      type: String,
      required: true
    },
    describe: {
      type: String,
      required: true
    }
  },
  data() {
    return {}
  }

}
</script>

<style lang="scss" scoped>
.k-msg {
  border: 1px solid #ccc;
  margin: 8px;
  border-radius: 4px;
  background: #edfbff;
  .k-m-title {
    height: 28px;
    line-height: 28px;
    padding: 0px 8px;
    border-bottom: 1px solid #d7ecf3;
  }
  .k-m-describe {
    padding: 8px 8px;
    font-size: 14px;
    text-indent: 28px;
    line-height: 21px;
  }
}
</style>